module.exports = __webpack_public_path__ + "img/hxzb-img10.900461b6.png";